export const createErrorSlice = (set) => ({
  marketUpdateError: '...',
  setMarketUpdateError: (error) => set({
    marketUpdateError: error,
    marketUpdateStarted: false
  }),
  resetMarketUpdateError: () => set({ marketUpdateError: '...' })
});
